import { DropdownLink } from '../../elements/common';

interface IProcessItemFooterProps {
    isItemOpen: boolean;
    labelLess: string;
    labelMore: string;
    onToggle: (isOpened: boolean) => void;
}

export function ProcessItemFooter(props: IProcessItemFooterProps) {
    return (
        <DropdownLink
            labelLess={props.labelLess}
            labelMore={props.labelMore}
            onClick={async () => props.onToggle(!props.isItemOpen)}
            open={props.isItemOpen}
        />
    );
}
